import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["width", "height"]
const _hoisted_2 = ["fill", "stroke"]


export default /*#__PURE__*/_defineComponent({
  name: 'XMark',
  props: {
    size: null,
    color: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    width: __props.size || 18,
    height: __props.size || 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    _createElementVNode("path", {
      d: "M9.13173 9.83884L16.5564 17.2635L17.2635 16.5564L9.83883 9.13173L17.2635 1.70711L16.5564 1L9.13173 8.42462L1.70711 1L1 1.70711L8.42462 9.13173L1 16.5564L1.70711 17.2635L9.13173 9.83884Z",
      fill: __props.color || '#4D4E58',
      stroke: __props.color || '#4D4E58',
      "stroke-width": "0.2"
    }, null, 8, _hoisted_2)
  ], 8, _hoisted_1))
}
}

})